import { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import SuccessIcon from '@mui/icons-material/CheckCircle'
import Delete from '@mui/icons-material/Delete'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { useSelector, useDispatch } from 'react-redux'
import { CvsAutoComplete, Paper } from '@components'
import * as TemplateActions from '../template.actions'
import { t } from '@lingui/core/macro'

const ParamSuccess = styled(SuccessIcon)`
  color: green;
`

const ParamError = styled(ErrorOutlineIcon)`
  color: red;
`

export const Parameter = ({ parameter, fields }) => {
  const dispatch = useDispatch()
  const [param, setParam] = useState(parameter)
  const [validParam, setValidParam] = useState(true)

  const isParamEncoded = () => {
    return param.url_encoding === 'standard'
  }

  const paramIsValid = param => {
    return !!(param.name.trim() !== '' && param.field_id)
  }

  const isNameEncoded = () => {
    return param.url_name_encoding === 'encoded' || !param.url_name_encoding
  }

  const urlNameEncodingEnabled = useSelector(
    state => state.Auth.features['url-name-encoding-option'],
  )

  const handleChange = (key, value) => {
    // flip that encoding.
    setParam(prev => ({ ...prev, [key]: value }))
  }

  useEffect(() => {
    dispatch(TemplateActions.setParameter({ ...param }))
    setValidParam(paramIsValid(param))
  }, [param])

  const removeParameter = () => {
    dispatch(TemplateActions.removeParameter(parameter))
  }

  useEffect(() => {
    return function cleanup() {
      // only update the store when these things are dismounted.
      // this doesn't work. infact it sucks.
      // dispatch(TemplateActions.setParameter(param))
    }
  }, [])

  return (
    <Paper elevation={3} style={{ width: '100%', padding: 12 }}>
      <Grid container>
        <Grid item xs={3}>
          <div style={{ flex: 1 }}>
            <div>
              <Typography variant="caption">{t`Parameter`}</Typography>
            </div>
            <div style={{ paddingRight: 12 }}>
              <TextField
                margin="dense"
                variant="outlined"
                fullWidth
                value={param.name}
                onChange={e => {
                  handleChange('name', e.target.value)
                }}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={3}>
          <div style={{ flex: 1 }}>
            <div>
              <Typography variant="caption">{t`Field`}</Typography>
            </div>
            <div style={{ paddingRight: 12 }}>
              <CvsAutoComplete
                margin="dense"
                options={fields}
                selected={param.field_id}
                onSelected={val => {
                  handleChange('field_id', val)
                }}
                style={{ marginTop: 0 }}
              />
            </div>
          </div>
        </Grid>
        <Grid item xs={2}>
          <div style={{ flex: 1 }}>
            <div>
              <Typography variant="caption">{t`Encoding`}</Typography>
            </div>
            <div style={{ paddingTop: 12 }}>
              <Tooltip
                title={t`Control whether this parameter value is url encoded`}
                placement="right"
              >
                <FormControlLabel
                  style={{ margin: 0 }}
                  control={
                    <Checkbox
                      checked={isParamEncoded(param)}
                      onChange={(e, newVal) => {
                        handleChange('url_encoding', newVal ? 'standard' : 'dynamic')
                      }}
                      value={isParamEncoded(param)}
                      style={{ padding: 2 }}
                      color="secondary"
                    />
                  }
                  label={t`URL parameter value encode`}
                />
              </Tooltip>
            </div>
          </div>
        </Grid>
        <Grid item xs={2}>
          {urlNameEncodingEnabled && (
            <div style={{ flex: 1 }}>
              <div style={{ paddingTop: 29 }}>
                <Tooltip
                  title={t`Control whether this parameter name is url encoded`}
                  placement="right"
                >
                  <FormControlLabel
                    style={{ margin: 0 }}
                    control={
                      <Checkbox
                        checked={isNameEncoded(param)}
                        onChange={(e, newVal) => {
                          handleChange('url_name_encoding', newVal ? 'encoded' : 'not_encoded')
                        }}
                        value={isNameEncoded(param)}
                        style={{ padding: 2 }}
                        color="secondary"
                      />
                    }
                    label={t`URL parameter name encode`}
                  />
                </Tooltip>
              </div>
            </div>
          )}
        </Grid>
        <Grid
          item
          xs={1}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          {validParam ? <ParamSuccess /> : <ParamError />}
        </Grid>
        <Grid
          item
          xs={1}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <Delete style={{ cursor: 'pointer', marginLeft: '15px' }} onClick={removeParameter} />
        </Grid>
      </Grid>
    </Paper>
  )
}
